module.exports = __webpack_public_path__ + "img/ic_32_sport_hockey-white.9d99e724.svg";